import type { CredentialType } from '@seek/ca-myprofile-utils';

import type {
  CertsyLinkAction,
  CertsyLinkPosition,
} from 'src/modules/analytics/certsy/eventNames';
import type { Action } from 'src/types';

import type { CertsyStatus } from '.';

export type CertsyActions = 'CERTSY_LINK_CLICKED';

export type CertsySections = 'next role' | 'education' | 'licence';

export type CertsyAction = Action<'CERTSY_LINK_CLICKED'> & {
  payload: {
    linkUrl?: string;
    linkAction: CertsyLinkAction;
    linkPosition: CertsyLinkPosition;
    credentialType: CredentialType;
    currentPageSection: CertsySections;
    certsyStatus?: CertsyStatus;
  };
};

export const certsyLinkClicked = ({
  linkUrl,
  linkAction,
  linkPosition,
  credentialType,
  currentPageSection,
  certsyStatus,
}: {
  linkUrl?: string;
  linkAction: CertsyLinkAction;
  linkPosition: CertsyLinkPosition;
  credentialType: CredentialType;
  currentPageSection: CertsySections;
  certsyStatus?: CertsyStatus;
}): CertsyAction => ({
  type: 'CERTSY_LINK_CLICKED',
  payload: {
    linkUrl,
    linkAction,
    linkPosition,
    credentialType,
    currentPageSection,
    certsyStatus,
  },
});
